// Card number / expiry / security code are Adyen "secured fields" rendered in cross-origin
// iframes: external CSS can't reach their text, so the colors must be set here. Without this the
// input text renders in Adyen's default dark color and is invisible on the dark background.
export const SECURED_FIELD_STYLES = {
  base: { color: '#ffffff', fontSize: '16px', fontWeight: '400', fontSmoothing: 'antialiased' },
  placeholder: { color: '#8f8f8f' },
  validated: { color: '#ffffff' },
  error: { color: '#f87171' },
};
